<template>
  <v-app-bar :elevation="2" class="header-bar">
    <img src="../assets/wgmm_eagle_logo.svg" height="26" class="img-responsive" @click="goHome" />
    <div class="header-text versions-text">
      {{ versionsText }}
    </div>
    <v-spacer></v-spacer>
    <v-menu :close-on-content-click="closeOnContentClick" open-on-hover bottom nudge-bottom="30" class="largeZ">
      <template v-slot:activator="{ props }">
        <div v-bind="props" class="header-text page-dropdown">{{ page }}
          <v-icon color="rgba(21, 102, 124, 0.9)" class="tinyIcon">mdi-chevron-down</v-icon>
        </div>
      </template>
      <v-list>
        <v-list-item v-for="(item, index) in pages" :key="index">
          <v-list-item @click="selectPage(item)"><span class="header-text page-item">{{
            item
              }}</span></v-list-item>
        </v-list-item>
      </v-list>
    </v-menu>
    <div @click="goHome" class="study-text"
      data-cy="study-view">
      {{ study }}
    </div>
    <v-menu :close-on-content-click="closeOnContentClick" open-on-hover bottom nudge-bottom="40" class="largeZ">
      <template v-slot:activator="{ props }">
        <v-btn icon v-bind="props">
          <v-icon color="rgba(21, 102, 124, 0.9)" data-cy="header-menu-dots">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="onUserGuideClicked"><span data-cy="header-menu-user-guide">USER GUIDE</span></v-list-item>
        <v-list-item @click="logout"><span data-cy="header-menu-logout">LOG OUT</span></v-list-item>
      </v-list>
    </v-menu>

  </v-app-bar>
</template>

<script>
import { authService } from "@/services/authService.js";
import { authTokenService } from "@/services/authTokenService.js";
import { STORE_CONSTANTS } from "@/common/store.constants";
import { commonService } from "@/services/common.service.js";
import { configService } from "@/services/config.service.js";
import router from "@/router";

export default {
  name: "Header",
  data: () => ({
    STORE_CONSTANTS,
    page: null,
    pages: [],
    study: null,
    closeOnContentClick: true,
    APIVersion: null,
    UIVersion: null,
    versionsText: null,
    drawer: false
  }),
  created() {
    this.page = authTokenService.getSelectedPage();
    this.study = authTokenService.getSelectedStudy();
    let roles = authTokenService.getRolesForStudy(this.study);

    if (roles.includes("ROLE_SPECIALIST") || roles.includes("ROLE_OPERATIONS") || roles.includes("FIELD_OPERATIONS")) {
      this.pages.push("Task Validation")
    }
    if (roles.includes("ROLE_SUPERVISOR") || roles.includes("ROLE_OPERATIONS")) {
      this.pages.push("Case Assignment")
    }
    if (roles.includes("ROLE_USER_MANAGE") || roles.includes("ROLE_OPERATIONS")) {
      this.pages.push("User Management")
    }
    if (roles.includes("FIELD_OPERATIONS") || roles.includes("ROLE_OPERATIONS")) {
      this.pages.push("Reporting")
    }
  },
  async beforeMount() {
    try {
      const response = await commonService.getUIAndApiVersion();
      if (response && response.data) {
        this.APIVersion = response.data.version;
      }
    } catch (err) {
      console.error(err);
    }
    this.UIVersion = configService.appVersion;
    this.versionsText = " UI: " + this.UIVersion + ", API: " + this.APIVersion
  },
  methods: {
    selectPage(page) {
      this.page = page;
      authTokenService.setSelectedPage(page);
      this.$store.dispatch('loadPage', page);

      const pageRoutes = {
        "Task Validation": "/validation",
        "Case Assignment": "/assignment",
        "User Management": "/management",
        "Reporting": "/reporting"
      };

      const route = pageRoutes[page];
      if (route) {
        this.$router.push(route);
      }
    },
    logout() {
      authService.logout(false);
    },
    goHome() {
      this.$router.push('/home')
    },
    onUserGuideClicked() {
      window.open("eagle_user_guide.pdf", '_blank')
    }
  },
};
</script>

<style scoped>
.header-bar {
  border-bottom: 2px solid #297286;
  background: linear-gradient(0.25turn, #f8f8ff, #e0e0e0, #f8f8ff);
}

.header-text {
  font-size: 1.5rem;
  color: rgba(21, 102, 124, 0.9);
}

.versions-text {
  margin-left: 20px;
  color: rgba(21, 102, 124, 0.7);
  font-size: 1.2rem;
}

.page-dropdown {
  cursor: pointer;
  
  margin-right: 5px;
}

.page-item {
  font-size: 1.2rem;
  color: rgba(21, 102, 124, 0.9);
  padding: 10px;
  text-transform: capitalize;
}

.study-text {
  cursor: pointer;
  font-size: 1.5rem;
  color: rgba(21, 102, 124, 0.9);
  margin-left: 10px;
  padding: 10px;
  margin-right: 10px;
  border-left: 1px dotted rgba(21, 102, 124, 0.2);
  border-right: 1px dotted rgba(21, 102, 124, 0.2);
}

.study-text:hover {
  background-color: rgba(21, 102, 124, 0.1);
}

.largeZ {
  z-index: 1000000000;
}

.v-menu__activator {
  padding: 5px;
  cursor: pointer;
}

.v-list-item {
  font-size: 1.1rem;
  color: rgba(21, 102, 124, 0.9);
}

.v-list-item:hover {
  background-color: rgba(21, 102, 124, 0.1);
}

/* Add a little padding to the menu items */
.v-list-item span {
  padding: 5px;
}

.v-btn {
  color: rgba(21, 102, 124, 0.9);
}
.tinyIcon {
  caret-color: rgba(21, 102, 124, 0.9);
    width: 9px;
    font-size: 1rem;
}
</style>
